<div style="display: flex; align-items: center;">
  <p-checkbox [(ngModel)]="checked" (click)="check($event)" binary="true"></p-checkbox>
</div>
